module.exports = __webpack_public_path__ + "media/homepage/mobile-training-load-261f8b00.jpg";